<template>
    <all-locations-section
        class="all-itsu-locations-section-module"
        :title="attributes.allItsuLocations_title"
        :areas="attributes.asyncData.areas"
    />
</template>

<script>
    import AllLocationsSection from '../../../organisms/AllLocationsSection/AllLocationsSection';

    export default {
        name: 'all-itsu-locations-section-module',

        components: { AllLocationsSection },

        props: {
            attributes: {
                type: Object,
                default: () => ({}),
            },
        },

        async asyncData({ store }) {
            const areas = await store.dispatch('itsu-locations/getAllItsuLocations');

            return {
                areas,
            };
        },
    };
</script>

